import React, { PureComponent } from 'react'
import { string, any, object } from 'prop-types'
import { Tooltip } from 'reactstrap'
import { translate } from 'react-i18next'
import './CopyToClipboard.css'

@translate()
export class CopyToClipboard extends PureComponent {
    static propTypes = {
        tag: string,
        id: string.isRequired,
        textToCopy: string.isRequired,
        children: any.isRequired,
        className: string,
        style: object
    }
    static defaultProps = {
        tag: 'div'
    }
    state = {
        tooltipOpen: false
    }
    tooltipToggle = () => this.setState({ tooltipOpen: !this.state.tooltipOpen })
    handleCopyToClipboard = () => copyToClipboard(this.props.textToCopy)

    render() {
        const { tag: Tag, id, textToCopy, children, className, style, t, tReady, ...otherProps } = this.props
        const { tooltipOpen } = this.state
        const tooltopId = `clipboard-tooltip-${id}`
        return (
            <Tag className={['CopyToClipboard', className]} style={style}>
                <span href="#" id={tooltopId} onClick={this.handleCopyToClipboard}>
                    {children}
                </span>
                <Tooltip
                    isOpen={tooltipOpen}
                    target={tooltopId}
                    toggle={this.tooltipToggle}
                    {...otherProps}
                >
                    {t('mc.gameDetail.copyToClipboard')}
                </Tooltip>
            </Tag>
        )
    }
}

export function copyToClipboard(str) {
    const el = document.createElement('textarea')
    el.value = str
    el.setAttribute('readonly', '')
    el.style.position = 'absolute'
    el.style.left = '-9999px'
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)
}




// WEBPACK FOOTER //
// src/components/CopyToClipboard/CopyToClipboard.js